export enum UserRole {
  ADMIN = 'admin',
  CUSTOMER = 'customer',
}

export enum UserGenre {
  M = 'M',
  F = 'F',
  O = 'O',
}

export enum UserStatus {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
}

export enum UserMenuOptions {
  PROFILE = 'PROFILE',
  PURCHASES = 'PURCHASES',
  FAVORITES = 'FAVORITES',
  LOGOUT = 'LOGOUT',
}

export enum DrawerActionType {
  EDIT = 'EDIT',
  ADD = 'ADD',
}

export enum PrefixPhone {
  CL = '+56',
}
